export default "__VITE_ASSET__f8173c88__"